var sizetable = {
    bra: {
        60.99: false,
        66.4: {
            76.19: false,
            78.79: "60C",
            81.39: "60D",
            83.99: "60E",
            86.59: "60F",
            89.19: "60G",
            91.79: "60H",
            94.39: "60I",
            96.99: "60J",
            99.59: "60K"
        },
        71.9: {
            76.19: false,
            78.79: "65A",
            81.39: "65B",
            83.99: "65C",
            86.59: "65D",
            89.19: "65E",
            91.79: "65F",
            94.39: "65G",
            96.99: "65H",
            99.59: "65I",
            102.19: "65J",
            104.79: "65K",
            107.39: "65L"
        },
        77.4: {
            81.34: false,
            83.99: "70A",
            86.59: "70B",
            89.19: "70C",
            91.79: "70D",
            94.39: "70E",
            96.99: "70F",
            99.59: "70G",
            102.19: "70H",
            104.79: "70I",
            107.39: "70J",
            109.99: "70K",
            112.59: "70L"
        },
        82.9: {
            86.59: false,
            89.19: "75A",
            91.79: "75B",
            94.39: "75C",
            96.99: "75D",
            99.59: "75E",
            102.19: "75F",
            104.79: "75G",
            107.39: "75H",
            109.99: "75I",
            112.59: "75J",
            115.19: "75K"
        },
        88.4: {
            91.79: false,
            94.39: "80A",
            96.99: "80B",
            99.59: "80C",
            102.19: "80D",
            104.79: "80E",
            107.39: "80F",
            109.99: "80G",
            112.59: "80H",
            115.19: "80I",
            117.79: "80J",
            120.39: "80K"
        },
        93.9: {
            95.39: false,
            97.99: "85AA",
            100.59: "85A",
            103.19: "85B",
            105.79: "85C",
            108.39: "85D",
            110.99: "85E",
            113.59: "85F",
            116.19: "85G",
            118.79: "85H",
            121.39: "85I",
            123.99: "85J",
            126.59: "85K"
        },
        99.4: {
            104.19: false,
            106.79: "90A",
            109.39: "90B",
            111.99: "90C",
            114.59: "90D",
            117.19: "90E",
            119.79: "90F",
            122.39: "90G",
            124.99: "90H",
            127.59: "90I",
            130.19: "90J",
            132.79: "90K"
        },
        104.9: {
            110.39: false,
            112.99: "95A",
            115.59: "95B",
            118.19: "95C",
            120.79: "95D",
            123.39: "95E",
            125.99: "95F",
            128.59: "95G",
            131.19: "95H",
            133.79: "95I",
            136.39: "95J",
            138.99: "95K"
        },
        109.9: {
            112.99: false,
            115.59: "100AA",
            118.19: "100A",
            120.79: "100B",
            123.39: "100C",
            125.99: "100D",
            128.59: "100E",
            131.19: "100F",
            133.79: "100G",
            136.39: "100H",
            138.99: "100I",
            141.59: "100J",
            144.19: "100K"
        },
        114.9: {
            118.19: false,
            120.79: "105AA",
            123.39: "105A",
            125.99: "105B",
            128.59: "105C",
            131.19: "105D",
            133.79: "105E",
            136.39: "105F",
            138.99: "105G",
            141.59: "105H",
            144.19: "105I",
            146.79: "105J",
            149.39: "105K"
        },
        119.9: {
            125.99: false,
            128.59: "110A",
            131.19: "110B",
            133.79: "110C",
            136.39: "110D",
            138.99: "110E",
            141.59: "110F",
            144.19: "110G",
            146.79: "110H",
            149.39: "110I",
            151.99: "110J",
            154.59: "110K"
        }
    },
    panty: {
        80: false,
        85: { eu: "32", filtersize: ["32"] },
        90: { eu: "34", filtersize: ["34"] },
        95: { eu: "36", filtersize: ["36"] },
        100: { eu: "36/38", filtersize: ["36", "38"] },
        105: { eu: "38/40", filtersize: ["38", "40"] },
        110: { eu: "40/42", filtersize: ["40", "42"] },
        115: { eu: "44/46", filtersize: ["44", "46"] },
        120: { eu: "48/50", filtersize: ["48", "50"] },
        125: { eu: "52/54", filtersize: ["52", "54"] },
        130: { eu: "56", filtersize: ["56"] },
        135: { eu: "58", filtersize: ["58"] }
    },
};

var sTemplate = document.querySelectorAll("[data-js-sizecalc-template]")[0].getAttribute("data-js-sizecalc-template")
    , storeUrl = `https://${window.sDomain}/api/2026-04/graphql.json`
    , accessToken = window.sStfKey
    , b_measure_needs_conv = typeof window.oMeasure.calc.value < "u" && window.oMeasure.calc.value != 0 && window.oMeasure.unit != ""
    , measure_operator = window.oMeasure.calc.operator ? window.oMeasure.calc.operator : ""
    , measure_value = window.oMeasure.calc.value ? Number(window.oMeasure.calc.value) : 0;

let measure_operations = {
    "+": (a, b) => a + b,
    "-": (a, b) => a - b,
    "*": (a, b) => a * b,
    "/": (a, b) => a / b
};

const DISPLAY_LIMIT = 6; 
const CANDIDATE_LIMIT = 50;

var query = `query search($productFilters: [ProductFilter!], $sizeKey: String!) @inContext(country: ${sCountry}) {
    search(
        query: ""
        first: ${CANDIDATE_LIMIT}
        types: PRODUCT
        productFilters: $productFilters
        unavailableProducts: HIDE
    ) {
        totalCount
        nodes {
            ... on Product {
                title
                handle
                createdAt
                images(first: 2) {
                    nodes {
                        transformedSrc(maxWidth: 300)
                    }
                }
                metafield(key: "sugarshapetype", namespace: "produkt") {
                    value
                }
                variants(first: 100) {
                    nodes {
                        availableForSale
                        sizeMetafield: metafield(key: $sizeKey, namespace: "filtergroesse") {
                            value
                        }
                    }
                }
            }
        }
    }
}`;

// productFilters only guarantees a variant with this size metafield EXISTS, not that it's in stock —
// keep only products whose matching variant is actually orderable
// (metafield is a list type, e.g. `["85G"]`, so its value is a JSON-encoded array, not a plain string)
function parseSizeMetafieldValues(raw) {
    try {
        const parsed = JSON.parse(raw);
        return Array.isArray(parsed) ? parsed : [raw];
    } catch {
        return [raw];
    }
}

function filterNodesByAvailableSize(nodes, sizeValues) {
    return (nodes || []).filter(node => {
        const variants = node.variants?.nodes || [];
        return variants.some(v => {
            if (v.availableForSale !== true || !v.sizeMetafield) return false;
            return parseSizeMetafieldValues(v.sizeMetafield.value).some(val => sizeValues.includes(val));
        });
    });
}

function buildProductCards(nodes) {
    return nodes.map(n => {
        // relative path resolves against the current domain automatically (fine for domain-per-market setups),
        // but has no locale path prefix — revisit if a subfolder-locale market is ever added
        const productUrl = `/products/${n.handle}`;
        return `<li class="collection-product-card quickview--hover quickview--hover"><div class="card-wrapper js-color-swatches-wrapper color-background-1"><span class="visually-hidden">${n.title}</span>  <div class="card card--product" tabindex="-1"><div class="card__inner full-unstyled-link"><div class="media media--transparent media--portrait media--hover-effect" style="padding-bottom: 130%;"><img src="${n.images.nodes[0].transformedSrc}" alt="${n.title}" width="300" height="384" loading="lazy" class="motion-reduce media--first" style="object-fit: cover;"><img src="${n.images.nodes[1].transformedSrc}" alt="${n.title}" width="300" height="384" loading="lazy" class="motion-reduce media--second" style="object-fit: cover;"></div><div class="card__information-top"></div></div></div>  <div class="card-information sus-card-information"><div class="card-information__wrapper"><div class="card-information__group"><h3 class="card__title sus-card-title h5"><a class="full-unstyled-link" href="${productUrl}" title="${n.title}">${n.title}</a><div class="sus-product-type block w-full">${n.metafield.value}</div></h3></div></div></div>     <a href="${productUrl}" class="link link--overlay card-wrapper__link--overlay js-color-swatches-link" aria-label="Produktlink"></a> </div></li>`;
    }).join("");
}

function fetchProducts(type, sizeValues, onSuccess, onError) {
    const variables = {
        productFilters: [
            ...sizeValues.map(value => ({ variantMetafield: { namespace: "filtergroesse", key: type, value } })),
            { productMetafield: { namespace: "produkt", key: "set", value: "false" } }
        ],
        sizeKey: type
    };    
    fetch(storeUrl, {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            "x-shopify-storefront-access-token": accessToken,
            "Accept-Language": sLang
        },
        body: JSON.stringify({ query, variables })
    })
    .then(r => { if (!r.ok) throw new Error("Network response was not ok"); return r.json(); })
    .then(data => {
        // sortKey: CREATED_AT (other ProductSortKeys options: RELEVANCE, BEST_SELLING, PRICE, TITLE, VENDOR, ...) —
        // `search` itself only supports RELEVANCE|PRICE as sortKey, so we sort client-side instead
        const availableNodes = filterNodesByAvailableSize(data.data.search.nodes, sizeValues)
            .sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt))
            .slice(0, DISPLAY_LIMIT);
        onSuccess(availableNodes.length, availableNodes);
    })
    .catch(onError);
}

function calcBraSizeMatch(sus_size, band_size, cup_size, variant_match) {
    var sId = sTemplate == "product" ? document.querySelectorAll("[data-js-sizecalc-id]")[0].getAttribute("data-js-sizecalc-id") : "";
    typeof gtag == "function" && gtag("event", "size_calc", { product: sId, sus_size, band: band_size, cup: cup_size, variant_match });
}

// Selecting a size disables button[name="add"] synchronously (VariantSelects.onVariantChange in global.js)
// and only re-enables it once its variant-info fetch resolves. Wait for that instead of clicking blind.
function clickAddButtonWhenReady(timeoutMs = 5000) {
    var oAddBtn = document.querySelector("button[name='add']");
    if (!oAddBtn) return;
    if (!oAddBtn.disabled) { oAddBtn.click(); return; }

    var timeoutId;
    var observer = new MutationObserver(() => {
        if (!oAddBtn.disabled) {
            observer.disconnect();
            clearTimeout(timeoutId);
            oAddBtn.click();
        }
    });
    observer.observe(oAddBtn, { attributes: true, attributeFilter: ["disabled"] });
    timeoutId = setTimeout(() => observer.disconnect(), timeoutMs);
}

function calcSizeBra() {
    var oResultBra = document.querySelector("[data-js-result-bra]")
        , oResultBraStringsContent = document.querySelectorAll("[data-js-result-strings-bra] span")
        , oResultBraBtnAction = document.querySelector("[data-js-action-bra]")
        , sLookupSize = ""
        , oSizeTable = sizetable.bra;

    oResultBra.classList.remove("sizecalc-results-positive");
    oResultBraStringsContent.forEach(el => el.classList.add("hidden"));
    oResultBraBtnAction.classList.add("hidden");

    var band = document.querySelector("[data-js-sizecalc-input-band]").value.replace(/[^0-9,.]/g, "").replace(",", ".")
        , cup = document.querySelector("[data-js-sizecalc-input-cup]").value.replace(/[^0-9,.]/g, "").replace(",", ".");

    if (b_measure_needs_conv && measure_operations[measure_operator]) {
        band = measure_operations[measure_operator](Number(band), measure_value).toFixed(1);
        cup = measure_operations[measure_operator](Number(cup), measure_value).toFixed(1);
    }

    var paBand = parseFloat(band), paCup = parseFloat(cup), bInputValid = true;

    if (!(paBand >= 50 && paBand <= 199)) { document.querySelector("[data-js-result-string-bra-err-band]").classList.remove("hidden"); bInputValid = false; }
    if (!(paCup >= 60 && paCup <= 199)) { document.querySelector("[data-js-result-string-bra-err-cup]").classList.remove("hidden"); bInputValid = false; }
    if (paBand > paCup) { document.querySelector("[data-js-result-string-bra-err-rel]").classList.remove("hidden"); bInputValid = false; }
    if (paCup - paBand < 5) { document.querySelector("[data-js-result-string-bra-err-diff]").classList.remove("hidden"); bInputValid = false; }
    if (!bInputValid) return;

    for (let maxBand in oSizeTable) {
        if (paBand <= maxBand) {
            let cups = oSizeTable[maxBand];
            if (cups === false) return calcOutput(false);
            for (let maxCup in cups) {
                if (paCup <= maxCup) {
                    sLookupSize = cups[maxCup] !== false ? cups[maxCup] : "";
                    return calcOutput(sLookupSize !== "");
                }
            }
            return calcOutput(false);
        }
    }
    calcOutput(false);

    function calcOutput(result) {
        if (!result) {
            document.querySelector("[data-js-result-string-bra-nosize]").classList.remove("hidden");
            calcBraSizeMatch("", paBand, paCup, false);
            if (sTemplate == "page") document.querySelector("[data-js-reco-wrapper-bra]").classList.add("hidden");
            return;
        }
        document.querySelector("[data-js-result-string-bra-pending]").classList.remove("hidden");
        fetchProducts("bhs", [sLookupSize],
            (totalCount, nodes) => {
                // const filter_url = `${window.location.origin}/collections/bhs?filter.v.m.filtergroesse.bhs=${sLookupSize.replace("/", "%2F").replace(",", "%2C")}`;
                const filter_url = `${window.location.origin}/collections/bhs?filter.v.m.filtergroesse.bhs=${sLookupSize}`;
                let sBaseSize = (window.sSizeSystem === 'uk' && window?.oSizeTable?.bra?.[sLookupSize.trim()]?.uk?.size)
                    ? window.oSizeTable.bra[sLookupSize.trim()].uk.size
                    : sLookupSize;
                let sSizeToShow = window?.bShowSussize && window?.oSizeTable?.bra[sLookupSize.trim()]?.sus?.size
                    ? sBaseSize + " (" + window.oSizeTable.bra[sLookupSize.trim()].sus.size + ")"
                    : sBaseSize;
                document.querySelector("[data-js-result-bra-size-value]").innerText = sSizeToShow;
                document.querySelector("[data-js-result-bra-size]").classList.remove("hidden");
                document.querySelector("[data-js-result-string-bra-pending]").classList.add("hidden");

                if (totalCount >= 1) {
                    oResultBra.classList.add("sizecalc-results-positive");

                    // ── Collection Page ───────────────────────────────────────
                    if (sTemplate == "collection") {
                        document.querySelector("[data-js-result-bra]").classList.remove("hidden");
                        document.querySelector("[data-js-result-bra-size]").classList.remove("hidden");
                        const sBand = sLookupSize.replace(/[A-Za-z]+$/, '');
                        const oBandInput = document.querySelector(`[data-js-facets-band] input[data-js-parent-size="${sBand}"]`);
                        const oCupInput = document.querySelector(`[data-js-size-children="${sBand}"] input[value="${sLookupSize}"]`);
                        const oBraActionBtnC = document.querySelector("[data-js-action-bra]");
                        const isSizeAvailable = !!oCupInput && !oCupInput.disabled;
                        oBraActionBtnC.querySelector("[data-js-action-size]").textContent = sBaseSize;
                        oBraActionBtnC.classList.remove("hidden");
                        if (typeof updateSizecalcApplyExclusivity === "function") updateSizecalcApplyExclusivity();
                        // calculated size isn't filterable in the current facet results (e.g. band exists but not with this cup) — layer on top of exclusivity's own state, don't override it
                        if (!isSizeAvailable) {
                            oBraActionBtnC.classList.add("is-sizecalc-disabled");
                            oBraActionBtnC.setAttribute("aria-disabled", "true");
                        }
                        oBraActionBtnC.onclick = e => {
                            e.preventDefault();
                            if (oBraActionBtnC.classList.contains("is-sizecalc-disabled")) return;
                            if (oBandInput && !oBandInput.checked) oBandInput.click();
                            if (oCupInput && !oCupInput.checked) oCupInput.click();
                            if (oBandInput) {
                                if (typeof BandSizeSelection === "function") BandSizeSelection(oBandInput);
                                if (typeof lastActiveBraBand !== "undefined") lastActiveBraBand = sBand;
                            }
                        };

                    // ── Page (Größenrechner-Seite) ────────────────────────────
                    } else if (sTemplate == "page") {
                        document.querySelector("[data-js-action-bra]").setAttribute("href", filter_url);
                        document.querySelector("[data-js-action-bra]").classList.remove("hidden");
                        document.querySelector("[data-js-reco-wrapper-bra]").classList.remove("hidden");
                        document.querySelector("[data-js-reco-content-bra]").innerHTML = buildProductCards(nodes);

                    // ── Product Page ──────────────────────────────────────────
                    } else if (sTemplate == "product") {
                        const sBandP = sLookupSize.replace(/[A-Za-z]+$/, '');
                        const oBandInputP = document.querySelector(`input[data-band="${sBandP}"]`);
                        const oCupInputP = document.querySelector(`input[data-cup][value="${sLookupSize}"]`);
                        if (oCupInputP) {
                            const target_avail = oCupInputP.getAttribute("data-avail")
                                , target_notify = oCupInputP.nextElementSibling?.classList.contains("button--notify");
                            if (target_avail == "false") {
                                if (oBandInputP && !oBandInputP.checked) {
                                    oBandInputP.checked = true;
                                    oBandInputP.dispatchEvent(new Event('change', { bubbles: true }));
                                }
                                oCupInputP.nextElementSibling?.click();
                                if (target_notify) { document.querySelector("[data-js-result-string-bra-product-nostock]").classList.remove("hidden"); }
                                else { document.querySelector("[data-js-result-string-bra-product-sold-url]").setAttribute("href", filter_url); document.querySelector("[data-js-result-string-bra-product-sold]").classList.remove("hidden"); }
                            } else {
                                const oBraActionBtn = document.querySelector("[data-js-action-bra]");
                                oBraActionBtn.querySelector("[data-js-action-size]").textContent = sBaseSize;
                                oBraActionBtn.classList.remove("hidden");
                                oBraActionBtn.onclick = e => {
                                    e.preventDefault();
                                    if (oBandInputP && !oBandInputP.checked) {
                                        oBandInputP.checked = true;
                                        oBandInputP.dispatchEvent(new Event('change', { bubbles: true }));
                                    }
                                    oCupInputP.nextElementSibling?.click();
                                    clickAddButtonWhenReady();
                                    const d = document.querySelector("[data-sus-size-helper-drawer]");
                                    if (d) { d.classList.remove("active"); document.body.classList.remove("overflow-hidden"); document.documentElement.classList.remove("overflow-hidden"); }
                                };
                            }
                        } else {
                            document.querySelector("[data-js-result-string-bra-product-nosize-url]").setAttribute("href", filter_url);
                            document.querySelector("[data-js-result-string-bra-product-nosize]").classList.remove("hidden");
                        }
                    }

                    calcBraSizeMatch(sLookupSize, paBand, paCup, true);
                } else {
                    document.querySelector("[data-js-result-string-bra-nostock]").classList.remove("hidden");
                    calcBraSizeMatch(sLookupSize, paBand, paCup, false);
                    if (sTemplate == "page") document.querySelector("[data-js-reco-wrapper-bra]").classList.add("hidden");
                }
            },
            error => {
                console.error("Error:", error);
                document.querySelector("[data-js-result-string-bra-err]").classList.remove("hidden");
                if (sTemplate == "page") document.querySelector("[data-js-reco-wrapper-bra]").classList.add("hidden");
            }
        );
    }
}

function calcSizePanty() {
    var oResultPanty = document.querySelector("[data-js-result-panty]")
        , oResultPantyStringsContent = document.querySelectorAll("[data-js-result-strings-panty] span")
        , oResultPantyBtnAction = document.querySelector("[data-js-action-panty]")
        , sLookupSize = ""
        , aFilterSizes = [];

    oResultPanty.classList.remove("sizecalc-results-positive");
    oResultPantyStringsContent.forEach(el => el.classList.add("hidden"));
    oResultPantyBtnAction.classList.add("hidden");

    var hip = document.querySelector("[data-js-sizecalc-input-hip]").value.replace(/[^0-9,.]/g, "").replace(",", ".");
    if (b_measure_needs_conv && measure_operations[measure_operator])
        hip = measure_operations[measure_operator](Number(hip), measure_value).toFixed(1);

    var paHip = parseFloat(hip)
        , rpaHip = parseFloat((Math.round(paHip / 5) * 5).toString().replace(".", ","))
        , oSizeTable = sizetable.panty;

    if (!(paHip >= 80 && paHip <= 199)) { document.querySelector("[data-js-result-string-panty-err-hip]").classList.remove("hidden"); return; }

    for (const key in oSizeTable) {
        if (key === `${rpaHip}`) {
            const match = oSizeTable[key];
            if (match) { sLookupSize = match.eu; aFilterSizes = match.filtersize; }
            calcOutput(!!match);
            break;
        }
    }
    calcOutput(false);

    function calcOutput(result) {
        if (!result) {
            if (sLookupSize == "") {
                document.querySelector("[data-js-result-string-panty-nosize]").classList.remove("hidden");
                if (sTemplate == "page") document.querySelector("[data-js-reco-wrapper-panty]").classList.add("hidden");
            }
            return;
        }
        document.querySelector("[data-js-result-string-panty-pending]").classList.remove("hidden");
        fetchProducts("hoeschen", aFilterSizes,
            (totalCount, nodes) => {
                const filter_url = `${window.location.origin}/collections/hoeschen?` + aFilterSizes.map(s => `filter.v.m.filtergroesse.hoeschen=${s}`).join("&");
                let sBaseSize = (window.sSizeSystem === 'uk' && window?.oSizeTable?.panty?.[sLookupSize.trim()]?.uk)
                    ? window.oSizeTable.panty[sLookupSize.trim()].uk
                    : sLookupSize;
                let sSizeToShow = window?.bShowSussize && window?.oSizeTable?.panty[sLookupSize.trim()]?.sus
                    ? sBaseSize + " (" + window.oSizeTable.panty[sLookupSize.trim()].sus + ")"
                    : sBaseSize;
                document.querySelector("[data-js-result-panty-size-value]").innerText = sSizeToShow;
                document.querySelector("[data-js-result-panty-size]").classList.remove("hidden");
                document.querySelector("[data-js-result-string-panty-pending]").classList.add("hidden");

                if (totalCount >= 1) {
                    document.querySelector("[data-js-result-panty]").classList.remove("hidden");
                    document.querySelector("[data-js-result-panty-size]").classList.remove("hidden");
                    oResultPanty.classList.add("sizecalc-results-positive");

                    // ── Collection Page ───────────────────────────────────────
                    if (sTemplate == "collection") {
                        const oPantyActionBtnC = document.querySelector("[data-js-action-panty]");
                        const isSizeAvailable = aFilterSizes.some(size => {
                            const oInput = document.querySelector(`[data-facet-size-panty] input[type="checkbox"][value="${size}"]`);
                            return oInput && !oInput.disabled;
                        });
                        oPantyActionBtnC.querySelector("[data-js-action-size]").textContent = sBaseSize;
                        oPantyActionBtnC.classList.remove("hidden");
                        if (typeof updateSizecalcApplyExclusivity === "function") updateSizecalcApplyExclusivity();
                        // calculated size isn't filterable in the current facet results — layer on top of exclusivity's own state, don't override it
                        if (!isSizeAvailable) {
                            oPantyActionBtnC.classList.add("is-sizecalc-disabled");
                            oPantyActionBtnC.setAttribute("aria-disabled", "true");
                        }
                        oPantyActionBtnC.onclick = e => {
                            e.preventDefault();
                            if (oPantyActionBtnC.classList.contains("is-sizecalc-disabled")) return;
                            aFilterSizes.forEach(size => {
                                const oInput = document.querySelector(`[data-facet-size-panty] input[type="checkbox"][value="${size}"]`);
                                if (oInput && !oInput.checked) {
                                    oInput.checked = true;
                                    oInput.dispatchEvent(new Event('input', { bubbles: true }));
                                }
                            });
                        };

                    // ── Page (Größenrechner-Seite) ────────────────────────────
                    } else if (sTemplate == "page") {
                        document.querySelector("[data-js-action-panty]").setAttribute("href", filter_url);
                        document.querySelector("[data-js-action-panty]").classList.remove("hidden");
                        document.querySelector("[data-js-reco-wrapper-panty]").classList.remove("hidden");
                        document.querySelector("[data-js-reco-content-panty]").innerHTML = buildProductCards(nodes);

                    // ── Product Page ──────────────────────────────────────────
                    } else if (sTemplate == "product") {
                        const allMatchingPanty = Array.from(document.querySelectorAll('input[data-panty-size]'))
                            .filter(el => {
                                const filters = (el.dataset.filter || '').split(',').map(s => s.trim());
                                return aFilterSizes.every(s => filters.includes(s));
                            });
                        const oPantyInput = allMatchingPanty.find(el => el.getAttribute('data-avail') !== 'false')
                            || allMatchingPanty[0]
                            || null;
                        if (oPantyInput) {
                            const target_avail = oPantyInput.getAttribute("data-avail")
                                , target_notify = oPantyInput.nextElementSibling?.classList.contains("button--notify");
                            if (target_avail == "false") {
                                oPantyInput.nextElementSibling?.click();
                                if (target_notify) { document.querySelector("[data-js-result-string-panty-product-nostock]").classList.remove("hidden"); }
                                else { document.querySelector("[data-js-result-string-panty-product-sold-url]").setAttribute("href", filter_url); document.querySelector("[data-js-result-string-panty-product-sold]").classList.remove("hidden"); }
                            } else {
                                const oPantyActionBtn = document.querySelector("[data-js-action-panty]");
                                oPantyActionBtn.querySelector("[data-js-action-size]").textContent = sBaseSize;
                                oPantyActionBtn.classList.remove("hidden");
                                oPantyActionBtn.onclick = e => {
                                    e.preventDefault();
                                    oPantyInput.nextElementSibling?.click();
                                    clickAddButtonWhenReady();
                                    const d = document.querySelector("[data-sus-size-helper-drawer]");
                                    if (d) { d.classList.remove("active"); document.body.classList.remove("overflow-hidden"); document.documentElement.classList.remove("overflow-hidden"); }
                                };
                            }
                        } else {
                            document.querySelector("[data-js-result-string-panty-product-nosize-url]").setAttribute("href", filter_url);
                            document.querySelector("[data-js-result-string-panty-product-nosize]").classList.remove("hidden");
                        }
                    }
                } else {
                    if (sTemplate == "product") {
                        if (totalCount == 0) { document.querySelector("[data-js-result-string-panty-product-nosize-nourl]").classList.remove("hidden"); return; }
                        let target_button = document.querySelector(`[data-js-label-std*="${sLookupSize}"]`);
                        if (target_button && target_button.length) { document.querySelector("[data-js-result-string-panty-product-nosize-url]").setAttribute("href", filter_url); document.querySelector("[data-js-result-string-panty-product-nosize]").classList.remove("hidden"); }
                        else if (target_button && target_button.classList.contains("button--notify")) { document.querySelector("[data-js-result-string-panty-product-nostock]").classList.remove("hidden"); }
                        else { document.querySelector("[data-js-result-string-panty-product-nosize-nourl]").classList.remove("hidden"); }
                    } else {
                        document.querySelector("[data-js-result-string-panty-nostock]").classList.remove("hidden");
                    }
                    if (sTemplate == "page") document.querySelector("[data-js-reco-wrapper-panty]").classList.add("hidden");
                }
            },
            error => {
                console.error("Error:", error);
                document.querySelector("[data-js-result-string-panty-err]").classList.remove("hidden");
                if (sTemplate == "page") document.querySelector("[data-js-reco-wrapper-panty]").classList.add("hidden");
            }
        );
    }
}

// nostock scroll-to link: close drawer first, then scroll (capture phase fires before base-sus.js handler)
// data-js-scroll-to/data-sus-size-helper-drawer only ever render on the product template — skip attaching elsewhere
if (sTemplate == "product") {
    document.addEventListener('click', e => {
        const link = e.target.closest('[data-js-scroll-to]');
        if (!link) return;
        const d = document.querySelector("[data-sus-size-helper-drawer]");
        if (!d) return;
        e.stopImmediatePropagation();
        e.preventDefault();
        d.classList.remove("active");
        document.body.classList.remove("overflow-hidden");
        document.documentElement.classList.remove("overflow-hidden");
        setTimeout(() => {
            const targetEl = document.getElementById(link.dataset.jsScrollTo);
            if (targetEl) targetEl.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }, 300);
    }, true);
}
